import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { EyeIcon, MousePointerIcon, HeadphonesIcon, MessageSquareIcon } from 'lucide-react';
export function Accessibility() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-365" data-mp="2ipykxaoqilrr">
      <Header data-id="element-366" data-mp="2dx5g6mt9ndfo" />
      <main className="flex-grow" data-id="element-367" data-mp="2dwm59q219pb5">
        {/* Hero Section */}
        <section className="bg-navy-800 text-white py-12" data-id="element-368" data-mp="2smbabwd8ydgp">
          <div className="container mx-auto px-4" data-id="element-369" data-mp="2skqfs6qxmuiu">
            <div className="max-w-3xl mx-auto text-center" data-id="element-370" data-mp="2no021q2lob0l">
              <h1 className="text-4xl font-bold mb-4" data-id="element-371" data-mp="2npkuna5ctjvt">
                Accessibility Statement
              </h1>
              <p className="text-lg" data-id="element-372" data-mp="2wo57huo8gzc4">
                Our commitment to digital inclusion and accessibility
              </p>
            </div>
          </div>
        </section>
        {/* Accessibility Statement Content */}
        <section className="py-12" data-id="element-373" data-mp="12anevt8z1ca8">
          <div className="container mx-auto px-4" data-id="element-374" data-mp="12boumb0xmmya">
            <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-375" data-mp="3bts9kt3luq5g">
              <div className="p-8" data-id="element-376" data-mp="3gsda6tmrrbuf">
                <div className="prose max-w-none" data-id="element-377" data-mp="3gtemt2jfo6e9">
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-378" data-mp="3lrpxtglgsmy2">
                    Our Commitment
                  </h2>
                  <p className="mb-6" data-id="element-379" data-mp="3qioc6amw7ayo">
                    The California Institute for Microbiome Research (CalMiR) is
                    committed to ensuring digital accessibility for people with
                    disabilities. We are continually improving the user
                    experience for everyone and applying the relevant
                    accessibility standards.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-380" data-mp="dav4arqk4ewn">
                    Conformance Status
                  </h2>
                  <p className="mb-6" data-id="element-381" data-mp="2a69d170yg0hq">
                    The Web Content Accessibility Guidelines (WCAG) define
                    requirements for designers and developers to improve
                    accessibility for people with disabilities. It defines three
                    levels of conformance: Level A, Level AA, and Level AAA.
                  </p>
                  <p className="mb-6" data-id="element-382" data-mp="2h1iz02k6qyoc">
                    The CalMiR website is partially conformant with WCAG 2.1
                    level AA. Partially conformant means that some parts of the
                    content do not fully conform to the accessibility standard.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-383" data-mp="2l1b8chhel8ur">
                    Accessibility Features
                  </h2>
                  <p className="mb-4" data-id="element-384" data-mp="2ztbv45ujx00a">
                    Our website includes the following accessibility features:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-385" data-mp="38r5mr3hdf5h4">
                    <li className="mb-2" data-id="element-386" data-mp="38pulbabee9t6">
                      Semantic HTML structure with proper headings and landmarks
                    </li>
                    <li className="mb-2" data-id="element-387" data-mp="3nee46m19w71j">
                      Text alternatives for non-text content
                    </li>
                    <li className="mb-2" data-id="element-388" data-mp="3sd775kixofng">
                      Keyboard accessibility for all functionality
                    </li>
                    <li className="mb-2" data-id="element-389" data-mp="3jd0we6emdtrz">Sufficient color contrast ratios</li>
                    <li className="mb-2" data-id="element-390" data-mp="3jb7ravjnnhm3">
                      Resizable text without loss of content or functionality
                    </li>
                    <li className="mb-2" data-id="element-391" data-mp="39fefxfho9u5w">
                      ARIA landmarks and attributes where appropriate
                    </li>
                  </ul>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-392" data-mp="2vlde2cvfbr1b">
                    Assistive Technologies Supported
                  </h2>
                  <p className="mb-4" data-id="element-393" data-mp="2lp0l5h7pdh7m">
                    We aim to support the following assistive technologies:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-394" data-mp="2qnlkzfj1lyvj">
                    <li className="mb-2" data-id="element-395" data-mp="3t219uajqwxra">
                      Screen readers (including JAWS, NVDA, VoiceOver, and
                      TalkBack)
                    </li>
                    <li className="mb-2" data-id="element-396" data-mp="3k9hhfru1rpew">Screen magnification software</li>
                    <li className="mb-2" data-id="element-397" data-mp="3k7d4yli31i30">Speech recognition software</li>
                    <li className="mb-2" data-id="element-398" data-mp="3f9lfrz8toa2i">Keyboard-only navigation</li>
                  </ul>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-399" data-mp="3accxlynoc619">
                    Known Limitations
                  </h2>
                  <p className="mb-4" data-id="element-400" data-mp="35ebbt5yv5sm3">
                    Despite our best efforts, there may be some aspects of our
                    website that are not fully accessible:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-401" data-mp="2wdlkofkjsqep">
                    <li className="mb-2" data-id="element-402" data-mp="zi7arwyeyys1">
                      Some older PDF documents may not be properly tagged for
                      screen reader accessibility
                    </li>
                    <li className="mb-2" data-id="element-403" data-mp="124gdbd28xqox">
                      Some complex data visualizations may not have adequate
                      text alternatives
                    </li>
                    <li className="mb-2" data-id="element-404" data-mp="1bsy9ti3htbmr">
                      Some third-party content or applications that we link to
                      may not be fully accessible
                    </li>
                  </ul>
                  <p className="mb-6" data-id="element-405" data-mp="j5uc7y6qbzl0">
                    We are actively working to address these issues and improve
                    the accessibility of our website.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-406" data-mp="t2ql450jinq3">
                    Feedback and Contact Information
                  </h2>
                  <p className="mb-6" data-id="element-407" data-mp="x2h9y36iatrz">
                    We welcome your feedback on the accessibility of the CalMiR
                    website. Please let us know if you encounter accessibility
                    barriers:
                  </p>
                  <div className="bg-gray-50 p-4 rounded mb-6" data-id="element-408" data-mp="9e7hxvw3znkh">
                    <p className="mb-2" data-id="element-409" data-mp="4fw9nplgpl4d">
                      <strong data-id="element-410" data-mp="4eumimr6986a">
                        California Institute for Microbiome Research
                      </strong>
                    </p>
                    <p className="mb-2" data-id="element-411" data-mp="dgknokauvlh9">Email: accessibility@calmir.org</p>
                    <p className="mb-2" data-id="element-412" data-mp="dhdiqo0gcmjk">Phone: (415) 555-0123</p>
                  </div>
                  <p className="mb-6" data-id="element-413" data-mp="3lwx8hd1wzmtv">
                    We try to respond to feedback within 2 business days.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-414" data-mp="3vm724xcepdk3">
                    Assessment and Compliance Process
                  </h2>
                  <p className="mb-6" data-id="element-415" data-mp="3qup1ybi7jh06">
                    The CalMiR website is regularly assessed for accessibility
                    compliance. Our assessment process includes:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-416" data-mp="2y61jsosr97qu">
                    <li className="mb-2" data-id="element-417" data-mp="1dp0tn6z99zox">
                      Internal testing with assistive technologies
                    </li>
                    <li className="mb-2" data-id="element-418" data-mp="1igaii5czcyzr">
                      Automated accessibility testing tools
                    </li>
                    <li className="mb-2" data-id="element-419" data-mp="14px71t0vr25o">
                      Periodic third-party accessibility audits
                    </li>
                    <li className="mb-2" data-id="element-420" data-mp="1xd17dkp12sb4">User feedback and reporting</li>
                  </ul>
                  <p className="mb-6" data-id="element-421" data-mp="21ecy5tjn1jkw">
                    We are committed to making ongoing improvements to our
                    website's accessibility.
                  </p>
                  <h2 className="text-2xl font-bold text-navy-800 mb-4" data-id="element-422" data-mp="1ngoj52c956nr">
                    Additional Resources
                  </h2>
                  <p className="mb-4" data-id="element-423" data-mp="byvqbnhjgyk1">
                    For more information about web accessibility, please visit
                    these resources:
                  </p>
                  <ul className="list-disc pl-6 mb-6" data-id="element-424" data-mp="18m31dccexhm2">
                    <li className="mb-2" data-id="element-425" data-mp="18nnvx1yq90jx">
                      <a href="https://www.w3.org/WAI/" className="text-teal-600 hover:text-teal-800" data-id="element-426" data-mp="13mzudmcvh1bg">
                        Web Accessibility Initiative (WAI)
                      </a>
                    </li>
                    <li className="mb-2" data-id="element-427" data-mp="tr6kkaqjflxd">
                      <a href="https://www.w3.org/TR/WCAG21/" className="text-teal-600 hover:text-teal-800" data-id="element-428" data-mp="1rcu6u2ta4nv6">
                        Web Content Accessibility Guidelines (WCAG) 2.1
                      </a>
                    </li>
                    <li className="mb-2" data-id="element-429" data-mp="1cog3zrvv4zem">
                      <a href="https://www.ada.gov/" className="text-teal-600 hover:text-teal-800" data-id="element-430" data-mp="1clll44shzmnb">
                        Americans with Disabilities Act (ADA)
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Accessibility Features Section */}
        <section className="py-12 bg-gray-50" data-id="element-431" data-mp="2ml4tpxph6nwd">
          <div className="container mx-auto px-4" data-id="element-432" data-mp="2mkcv0e0l0a1v">
            <div className="max-w-4xl mx-auto" data-id="element-433" data-mp="2rladkrpi763w">
              <h2 className="text-2xl font-bold text-navy-800 mb-8 text-center" data-id="element-434" data-mp="2rm2b482nvdwt">
                Our Accessibility Features
              </h2>
              <div className="grid md:grid-cols-4 gap-6" data-id="element-435" data-mp="30l746yvgef1l">
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-436" data-mp="30jm998588u37">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-437" data-mp="35cp8nwwoqxrb">
                    <EyeIcon size={24} className="text-teal-600" data-id="element-438" data-mp="3adcxcbxfz2id" />
                  </div>
                  <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-439" data-mp="3fc6c07ogszk4">
                    Visual
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-440" data-mp="3k72395lvniw6">
                    High contrast, resizable text, and alternative text for
                    images
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-441" data-mp="2s6683zf4rx2b">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-442" data-mp="2x6aozqjyatt2">
                    <MousePointerIcon size={24} className="text-teal-600" data-id="element-443" data-mp="3206juk4x40k0" />
                  </div>
                  <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-444" data-mp="36zrpfdelf75p">
                    Motor
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-445" data-mp="3fxlgo9xi3am0">
                    Keyboard navigation and large clickable areas
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-446" data-mp="3kv3q01ffjruj">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-447" data-mp="1lln9semnyqta">
                    <HeadphonesIcon size={24} className="text-teal-600" data-id="element-448" data-mp="1ql9lukqra10i" />
                  </div>
                  <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-449" data-mp="1j1qw7vn0b9iy">
                    Auditory
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-450" data-mp="199l4mn0o2u4a">
                    Captions for video content and transcripts for audio
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-451" data-mp="148oqlgmlprl5">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-452" data-mp="21y06e7usffxo">
                    <MessageSquareIcon size={24} className="text-teal-600" data-id="element-453" data-mp="1wxceljyqiv2e" />
                  </div>
                  <h3 className="text-lg font-bold text-navy-700 mb-2" data-id="element-454" data-mp="1s2f7wjoxgxso">
                    Cognitive
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-455" data-mp="gkxead129ejv">
                    Clear navigation, consistent layout, and readable content
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-456" data-mp="e1akv0zrpa7b" />
    </div>;
}